import { render, staticRenderFns } from "./AddRoles.vue?vue&type=template&id=3ffda072&scoped=true"
import script from "./AddRoles.vue?vue&type=script&lang=js"
export * from "./AddRoles.vue?vue&type=script&lang=js"
import style0 from "./AddRoles.vue?vue&type=style&index=0&id=3ffda072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffda072",
  null
  
)

export default component.exports